// Tutorial completion / skip flag, persisted to localStorage. Read on boot to
// decide whether to play the tutorial between language pick and splash.

const STORAGE_KEY = 'games:tutorial';

export interface TutorialState {
  completed: boolean;
  skipped: boolean;
}

const DEFAULTS: TutorialState = { completed: false, skipped: false };

export function loadTutorialState(): TutorialState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    return {
      completed: typeof parsed.completed === 'boolean' ? parsed.completed : DEFAULTS.completed,
      skipped: typeof parsed.skipped === 'boolean' ? parsed.skipped : DEFAULTS.skipped
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveTutorialState(s: TutorialState): void {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch { /* quota / private mode — ignore */ }
}

export function resetTutorialState(): void {
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
}

export function shouldRunTutorial(): boolean {
  const s = loadTutorialState();
  return !s.completed && !s.skipped;
}
